import {useState} from "react";
import {NONE_STATUS, PENDING_STATUS, SUCCESS_STATUS} from "../../actions";
import useErrorHandler from "./use-error-handler";
import axios from "axios";
import {useAuthorization} from "../../selectors";
import {getIncrementMediaViewcountUrl, getPublicIncrementMediaViewcountUrl} from "../../actions/environment";
import {authConfig} from "../../actions/local-storage";
import {useParams} from "react-router-dom";

const useIncrementMediaViewcount = () => {
    const [status, setStatus] = useState(NONE_STATUS);
    const [viewcount, setViewcount] = useState(0);
    const {isAuthorized, principalUsername} = useAuthorization();
    const {username} = useParams();
    const {handleError, error} = useErrorHandler(setStatus);

    const incrementMediaViewcount = (mediaId, callback) => {
        const url = resolveUrl(mediaId)

        setStatus(PENDING_STATUS);
        axios.put(url, {}, authConfig())
        .then(response => {
            callback && callback(response.data);
            setViewcount(response.data.viewcount);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            console.log('incrementMediaViewcount', error);
            handleError(error, () => incrementMediaViewcount(mediaId, callback));
        })
    }

    // principal when loggedin and username from url if not
    const resolveUrl = (mediaId) => {
        return isAuthorized ?
            getIncrementMediaViewcountUrl(principalUsername, mediaId) :
            getPublicIncrementMediaViewcountUrl(username, mediaId);
    }

    return {incrementMediaViewcount: incrementMediaViewcount,
        viewcount: viewcount, status: status, error: error};
};
export default useIncrementMediaViewcount;
